import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function USPList({ CTA, headingText, maxWidth, USPs }) {
  return (
    <div
      className={clsx(
        'flex min-h-[400px] w-full flex-col justify-between gap-4 bg-[#FAF5FD] p-4 text-white shadow-xl ring-1 ring-[#9D54D8] md:p-8',
        {
          'max-w-sm': maxWidth === 'sm',
          'max-w-md': maxWidth === 'md',
          'max-w-lg': maxWidth === 'lg',
          'max-w-xl': maxWidth === 'xl'
        }
      )}
    >
      <div className="space-y-4">
        {headingText && (
          <h2 className="m-0 text-lg font-bold text-[#9D54D8]">
            {headingText}
          </h2>
        )}
        <div className="space-y-4 text-sm text-black">
          {USPs.map(USP => (
            <div className="flex items-start space-x-2" key={USP.headline}>
              {typeof USP.icon === 'object' ? (
                USP.icon
              ) : (
                <img
                  className="h-6 w-6 shrink-0 text-[#9D54D8]"
                  src={USP.icon}
                  alt=""
                />
              )}
              <div className="mt-0.5 flex flex-col">
                <span className="font-semibold">{USP.headline}</span>
                {USP.body && <span>{USP.body}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
      {CTA && CTA.content && (
        <button
          className="flex w-full cursor-pointer items-center justify-center gap-x-2 border-0 bg-[#FAF5FD] p-4 text-sm font-bold text-[#9D54D8] ring-1 ring-[#9D54D8] transition-shadow hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9D54D8] focus-visible:ring-offset-2"
          type="button"
          onClick={CTA.onClick}
        >
          {CTA.content}
        </button>
      )}
    </div>
  );
}

USPList.propTypes = {
  CTA: PropTypes.shape({
    content: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  /**
   * Defines the Text of the Heading inside of the USP List component.
   */
  headingText: PropTypes.string,
  /**
   * Defines the Maximum Width of the USP List component.
   */
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  /**
   * An Array of Objects containing the USP.
   */
  USPs: PropTypes.arrayOf(
    PropTypes.shape({
      body: PropTypes.string,
      headline: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
    })
  ).isRequired
};

USPList.defaultProps = {
  CTA: undefined,
  headingText: undefined,
  maxWidth: 'md'
};

export default USPList;
